<div 
    class="modal fade show" 
    [ngClass]="{'expanded': isExpanded}"
    id="config-modal" 
    tabindex="-1" 
    aria-labelledby="config-modalLabel" 
    aria-hidden="true"
    [ngStyle]="{'display': 'block'}"
>
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <div class="d-flex w-100">
                    <div class="me-2 id">
                        <h4 class="modal-title mb-0 item-id">Customers</h4>
                        <!-- <h4 class="modal-title mb-0 item-id">{{ gridType === 'config' ? 'Configurations' : 'Customers' }}</h4> -->
                    </div>
                    <div class="btns-header ms-auto">
                        <button 
                            class="header-icon close p-0 m-0" 
                            (click)="close()" 
                            aria-label="Close"
                        >
                            <i 
                                class="fas fa-times" 
                                title="Close Popup"
                            ></i>
                        </button>
                        <button 
                            class="close header-icon expand-modal p-0 m-0"
                            (click)="isExpanded = !isExpanded"
                        >
                            <i 
                                class="fas ms-2 me-2" 
                                [ngClass]="{'fa-expand-alt': !isExpanded, 'fa-compress-alt': isExpanded}" 
                                [title]="isExpanded ? 'Exit Full Screen' : 'Enter Full Screen'"
                            ></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="modal-body pt-3">
                <div class="row">
                    <div class="col">
                        @if (USER?.role === userRoles.iscManager || USER?.role === userRoles.isc || USER?.role === userRoles.IscSupervisor) {
<div class="row mb-3">
                            <div class="col field">
                                <label>Customer Name:<span class="required-asterik">*</span></label>
                                <ejs-textbox
                                    placeholder="Customer Name"
                                    (change)="this.customerName = $event.value"
                                ></ejs-textbox>
                                @if (validationApplied && !this.customerName) {
<div class="field-error">First Name is required</div>
}
                            </div>
                            <div class="col field">
                                <label>City:<span class="required-asterik">*</span></label>
                                <ejs-textbox
                                    placeholder="City"
                                    (change)="this.city = $event.value"
                                ></ejs-textbox>
                                @if (validationApplied && !this.city) {
<div class="field-error">City is required</div>
}
                            </div>
                            <div class="col field">
                                <label>State: <span class="required-asterik">*</span></label>
                                <ejs-textbox
                                    placeholder="State"
                                    (change)="this.state = $event.value"
                                ></ejs-textbox>
                                @if (validationApplied && !this.state) {
<div class="field-error">State is required</div>
}
                            </div>
                            <div class="col field">
                                <label>Zip Code:</label>
                                <ejs-textbox
                                    placeholder="Zip Code"
                                    (change)="this.zipCode = $event.value"
                                ></ejs-textbox>
                            </div>
                            <div class="col field">
                                <label>Address:</label>
                                <ejs-textbox
                                    placeholder="Address"
                                    (change)="this.address = $event.value"
                                ></ejs-textbox>
                            </div>
                            <div class="col">
                                <button class="btn btn-sm btn-success" (click)="getCustomers($event)"> Search</button>
                            </div>

                        </div>
}
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        @if (gridConfig) {
<div [style.height.px]="gridHeight">
                            <inavista-grid #serviceOrderGrid class="so-popup-grid"
                                [config]="gridConfig"
                                [actionIcons]="actionIcons"
                                (rowSelected)="rowSelected($event)"
                                (actionIconClick)="onActionIconClick($event)" />
                        </div>
}
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-danger close-modal" (click)="close()">Close</button>
                <!-- <button type="button" class="btn btn-sm btn-success" [disabled]="!selectedRowData" (click)="proceed()">Proceed</button> -->
            </div>
        </div>
    </div>
</div>